<div [formGroup]="group">
  <button class="btn btn-primary" [disabled]="config.disabled" type="submit"
    [id]="config.fullyQualifiedName" [name]="config.fullyQualifiedName">
    {{ config.label | translate }}
  </button>
</div>
